import Vue from 'vue'
import App from './App.vue'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/amb-poker-stylesheet.css'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueEasySession from 'vue-easysession'
import Antd from 'ant-design-vue'
import i18n from './i18n'

var options = {
  persist: false,
  keySession: 'ambpoker-session',
  expireSessionCallback: () => {
    window.location.href = '/'
  }
}

Vue.use(BootstrapVue)
Vue.use(VueEasySession.install, options)
Vue.use(AOS)
Vue.use(Antd)
Vue.use(Vuex)
Vue.component('modal', {
  template: '#modal-template'
})

Vue.use(VueAxios, axios)

Vue.axios.defaults.headers.common['x-result-ambpoker'] = 'TGI18jk3IOACMzRjMDhhOTQyMjQ4YjijNDMzZDZk789='
Vue.config.productionTip = false

new Vue({
  created () {
    AOS.init({
      duration: 1200,
    })
  },

  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
